export const COURSE_FORM_TYPES = {
  APPLICATION: 1,
};

export const COURSE_FORM_FIELD_TYPES = {
  TEXT: 4,
  EMAIL: 5,
  PESEL: 6,
  NUMBER: 7,
  DICTIONARY: 8,
  DATE: 9,
  BOOLEAN: 10,
  USER_PHONE: 11,
  BORN_DATE: 12,
  BORN_PLACE: 13,
} as const;

export const COURSE_FORM_FIELD_TYPES__DATES_TYPES = [
  COURSE_FORM_FIELD_TYPES.DATE,
  COURSE_FORM_FIELD_TYPES.BORN_DATE,
] as number[];

export const COURSE_FORM_FIELD_TYPES_NAMES = {
  [COURSE_FORM_FIELD_TYPES.TEXT]: "Tekst",
  [COURSE_FORM_FIELD_TYPES.EMAIL]: "Email",
  [COURSE_FORM_FIELD_TYPES.PESEL]: "PESEL",
  [COURSE_FORM_FIELD_TYPES.NUMBER]: "Numer",
  [COURSE_FORM_FIELD_TYPES.DICTIONARY]: "Pole wyboru",
  [COURSE_FORM_FIELD_TYPES.DATE]: "Data",
  [COURSE_FORM_FIELD_TYPES.BOOLEAN]: "Prawda/Fałsz",
  [COURSE_FORM_FIELD_TYPES.USER_PHONE]: "Telefon użytkownika",
  [COURSE_FORM_FIELD_TYPES.BORN_DATE]: "Data urodzenia",
  [COURSE_FORM_FIELD_TYPES.BORN_PLACE]: "Miejsce urodzenia",
};

export const FORM_INPUT_OPTIONS = Object.entries(
  COURSE_FORM_FIELD_TYPES_NAMES
).map(([key, value]) => ({
  value: parseInt(key),
  label: value,
}));

export const FIELD_CONDITIONS_IDS = {
  EQUAL: 1,
  NOT_EQUAL: 2,
  LESS: 3,
  LESS_OR_EQUAL: 4,
  GREATER: 5,
  GREATER_OR_EQUAL: 6,
};

export const FIELD_CONDITIONS_POSSIBLE_OPTIONS = {
  [COURSE_FORM_FIELD_TYPES.TEXT]: [
    { value: FIELD_CONDITIONS_IDS.EQUAL, label: "Równe" },
    { value: FIELD_CONDITIONS_IDS.NOT_EQUAL, label: "Różne od" },
  ],
  [COURSE_FORM_FIELD_TYPES.BORN_PLACE]: [
    { value: FIELD_CONDITIONS_IDS.EQUAL, label: "Równe" },
    { value: FIELD_CONDITIONS_IDS.NOT_EQUAL, label: "Różne od" },
  ],
  [COURSE_FORM_FIELD_TYPES.EMAIL]: [
    { value: FIELD_CONDITIONS_IDS.EQUAL, label: "Równe" },
    { value: FIELD_CONDITIONS_IDS.NOT_EQUAL, label: "Różne od" },
  ],
  [COURSE_FORM_FIELD_TYPES.PESEL]: [
    { value: FIELD_CONDITIONS_IDS.EQUAL, label: "Równe" },
    { value: FIELD_CONDITIONS_IDS.NOT_EQUAL, label: "Różne od" },
  ],
  [COURSE_FORM_FIELD_TYPES.USER_PHONE]: [],

  [COURSE_FORM_FIELD_TYPES.NUMBER]: [
    { value: FIELD_CONDITIONS_IDS.EQUAL, label: "Równe" },
    { value: FIELD_CONDITIONS_IDS.NOT_EQUAL, label: "Różne od" },
    { value: FIELD_CONDITIONS_IDS.LESS, label: "Mniejsze od" },
    {
      value: FIELD_CONDITIONS_IDS.LESS_OR_EQUAL,
      label: "Mniejsze lub równe od",
    },
    { value: FIELD_CONDITIONS_IDS.GREATER, label: "Większe od" },
    {
      value: FIELD_CONDITIONS_IDS.GREATER_OR_EQUAL,
      label: "Większe lub równe od",
    },
  ],
  [COURSE_FORM_FIELD_TYPES.DICTIONARY]: [
    { value: FIELD_CONDITIONS_IDS.EQUAL, label: "Równe" },
    { value: FIELD_CONDITIONS_IDS.NOT_EQUAL, label: "Różne od" },
  ],
  [COURSE_FORM_FIELD_TYPES.DATE]: [
    { value: FIELD_CONDITIONS_IDS.EQUAL, label: "Równe" },
    { value: FIELD_CONDITIONS_IDS.NOT_EQUAL, label: "Różne od" },
    { value: FIELD_CONDITIONS_IDS.LESS, label: "Mniejsze od" },
    {
      value: FIELD_CONDITIONS_IDS.LESS_OR_EQUAL,
      label: "Mniejsze lub równe od",
    },
    { value: FIELD_CONDITIONS_IDS.GREATER, label: "Większe od" },
    {
      value: FIELD_CONDITIONS_IDS.GREATER_OR_EQUAL,
      label: "Większe lub równe od",
    },
  ],
  [COURSE_FORM_FIELD_TYPES.BORN_DATE]: [
    { value: FIELD_CONDITIONS_IDS.EQUAL, label: "Równe" },
    { value: FIELD_CONDITIONS_IDS.NOT_EQUAL, label: "Różne od" },
    { value: FIELD_CONDITIONS_IDS.LESS, label: "Mniejsze od" },
    {
      value: FIELD_CONDITIONS_IDS.LESS_OR_EQUAL,
      label: "Mniejsze lub równe od",
    },
    { value: FIELD_CONDITIONS_IDS.GREATER, label: "Większe od" },
    {
      value: FIELD_CONDITIONS_IDS.GREATER_OR_EQUAL,
      label: "Większe lub równe od",
    },
  ],
  [COURSE_FORM_FIELD_TYPES.BOOLEAN]: [
    { value: FIELD_CONDITIONS_IDS.EQUAL, label: "Równe" },
    { value: FIELD_CONDITIONS_IDS.NOT_EQUAL, label: "Różne od" },
  ],
};

export const FIELD_CONDITIONS_TEXTS = {
  [FIELD_CONDITIONS_IDS.EQUAL]: "równe",
  [FIELD_CONDITIONS_IDS.NOT_EQUAL]: "różne od",
  [FIELD_CONDITIONS_IDS.LESS]: "mniejsze od",
  [FIELD_CONDITIONS_IDS.LESS_OR_EQUAL]: "mniejsze lub równe od",
  [FIELD_CONDITIONS_IDS.GREATER]: "większe od",
  [FIELD_CONDITIONS_IDS.GREATER_OR_EQUAL]: "większe lub równe od",
};
